export { default as AutoSelectRestaurant } from './auto-select-restaurant';
